<template>
  <div class="fullbox">
    <div class="crumbs">
      <div class="goBack" @click="goBack">
        <i class="el-icon-arrow-left"></i> 返回
      </div>
      <div class="title">分类管理</div>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%" :max-height="tableHeight">
        <el-table-column
          type="index"
          label="序号"
          width="250"
          align="center"
        ></el-table-column>
        <el-table-column label="分类名称" align="center">
          <template slot-scope="scope">
            <!-- <div style="color: rgba(25, 144, 255, 1)">{{ scope.row.name }}</div> -->
            <div v-if="scope.row.isEditingName">
              <el-input
                @blur="changeName(scope.row)"
                v-model="scope.row.name"
                size="small"
              />
            </div>
            <div style="color: rgba(25, 144, 255, 1)" v-else>
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="parentName" label="所属分类" align="center">
        </el-table-column>
        <!-- <el-table-column label="权重">
          <template slot-scope="scope">
            <div v-if="scope.row.isEditing">
              <el-input
                type="number"
                @blur="changeWeight(scope.row)"
                v-model="scope.row.weight"
                size="small"
              />
            </div>
            <div v-else>
              {{ scope.row.weight }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
            <div class="operate">
              <!-- <div @click="editRow(scope.row)">编辑</div> -->
              <div
                @click="hideRow(scope.row, 0)"
                v-if="scope.row.hiddenStatus == 1"
              >
                取消隐藏
              </div>
              <div
                @click="hideRow(scope.row, 1)"
                v-if="scope.row.hiddenStatus == 0"
              >
                隐藏
              </div>
              <div @click="delRow(scope.row)">删除</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import api from "@/apis/logistics";
export default {
  components: {},
  data() {
    return {
      tableData: [],
      tableHeight: window.innerHeight - 200,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {

    //获取分类管理列表
    getList() {
      api.queryList().then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
      });
      // this.tableData.forEach((item) => {
      //   this.$set(item, "isEditing", false);
      //   this.$set(item, "isEditingName", false);
      // });
    },
    //编辑
    editRow(row) {
      this.$set(row, "isEditing", true);
      this.$set(row, "isEditingName", true);
    },
    //改变权重
    changeWeight(row) {
      this.$set(row, "isEditing", false);
    },
    //改变名称
    changeName(row) {
      this.$set(row, "isEditingName", false);
    },
    //隐藏
    hideRow(row, type) {
      console.log(row);
      this.$confirm(`此操作将${type == 0 ? "取消隐藏" : "隐藏"}该分类, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.updateMenu({ id: row.id, hiddenStatus: type }).then((res) => {
            if (res.code == 200) {
              this.$message.success("隐藏成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    //删除
    delRow(row) {
      this.$confirm("此操作将删除该分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.updateMenu({ id: row.menuId, status: 1 }).then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    //返回
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: hidden;
  padding: 40px;
  .crumbs {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 20px;
    padding: 30px 40px;
    .goBack {
      font-size: 28px;
      color: rgba(102, 102, 102, 1);
      margin-right: 45px;
      cursor: pointer;
      i {
        margin-right: 10px;
      }
    }
    .title {
      font-size: 34px;
      font-weight: bold;
    }
  }
  .table {
    background: #fff;
    border-radius: 20px;
    padding: 60px 80px;
    height: 88vh;
    margin-top: 40px;
    ::v-deep {
      .cell {
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
      }
      thead tr th {
        background: rgba(250, 250, 250, 1);
        .cell {
          height: 80px;
        }
      }
    }
    .operate {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: rgba(79, 162, 125, 1);
    }
  }
}
</style>
